<template>
  <div>
    <PanelNavBar />
    <router-view />
    <chat-assistant />
    <Footer />
  </div>
</template>

<script>
import PanelNavBar from '../components/partials/PanelNavBar.vue';
import Footer from '../components/partials/Footer.vue';
import ChatAssistant from '../components/ChatAssistant.vue';
/*import CreatorUpdateData from '../components/partials/CreatorUpdateData.vue';*/

export default {
    components: {
        PanelNavBar,
        Footer,
        ChatAssistant,
        /*CreatorUpdateData*/
    },
    data () {
        return {
            modal: false
        }
    },
    metaInfo: {
        titleTemplate: '%s - Harmony Fan',
        title: 'Panel'
    }
};
</script>

<style scoped>
    #app {
        background: #f1eeff !important;
    }
</style>